import React, { useRef, useState } from "react";
// components
import Iconify from "../components/Iconify";
import HeadingAnimate from "../components/animate/HeadingAnimate";
import LoadAnimate from "../components/animate/LoadAnimate";
import AnimatedLottie from "../components/Lottie";
import axios from "../utils/axios";
// mock
import { contactInfo } from "../mock/profile";
import contactAnimationData from "../mock/lottie/contact.json";
import { Icon } from "@iconify/react/dist/iconify.js";

// ----------------------------------------------------------------------

export default function Contact() {
  const [isSending, setIsSending] = useState(false);

  const formRef = useRef();

  const sendEmail = async (e) => {
    e.preventDefault();
    try {
      setIsSending(true);
      const result = await axios.post("/contact", {
        name: formRef.current.name.value,
        email: formRef.current.email.value,
        message: formRef.current.message.value,
      });
      if (result) alert("Sent Successfully!");
    } catch (error) {
      alert("Sending failed!");
    } finally {
      setIsSending(false);
      formRef.current.message.value = "";
    }
  };
  return (
    <>
      <div
        className="bg-[#1e1e1e] w-screen h-screen flex justify-center pt-16 bg-blend-overlay bg-cover bg-fixed bg-center"
        style={{ backgroundImage: `url('/assets/backImg/bg17.jpg')` }}
        id="contact"
      >
        <div className="container">
          <div className=" flex flex-col justify-center items-center gap-5">
            <div>
              <p className="text-[48px] font-bold leading-[55px]">
                Let's talk!
              </p>
            </div>
            <div className="flex justify-center text-center">
              <p className="text-[18px] mb-0 text-[#d8d8d8]">
                Let's embark on this journey to build remarkable solutions for a
                brighter future!
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row mt-8">
            <div className="flex-1">
              <div class="bg-[#222121] border-2 border-solid border-[#464646] rounded-[5px] h-full shadow-[0_5px_15px_0_rgba(68,68,68,.1)] pt-[60px] sm:pl-10 sm:pr-10 pb-[30px] mb-[60px]">
                <h2 className="text-center font-lato text-2xl font-semibold text-primary-700 dark:text-cyan-400 sm:text-4xl">
                  Get In Touch
                </h2>
                <div className="m-2 flex flex-col items-center md:flex-row max-w-3xl mt-10">
                  <form ref={formRef} onSubmit={sendEmail} className="w-full">
                    <div className="relative w-full p-2">
                      <div className="absolute left-5 top-4 font-semibold text-primary-700 dark:text-cyan-400">
                        Name{" "}
                      </div>
                      <input
                        type="text"
                        id="name"
                        required
                        placeholder="Full Name"
                        name="user_name"
                        className="w-full rounded border border-[#464646] bg-primary-100/20 py-1 pl-16 pr-3 text-base leading-8 outline-none transition-colors duration-200 ease-in-out focus:ring-1 focus:ring-primary-700/70 dark:border-[#464646] dark:bg-primary-300/10 dark:focus:ring-primary-300/50"
                      />
                    </div>
                    <div className="relative w-full p-2">
                      <div className="absolute left-5 top-4 font-semibold text-primary-700 dark:text-cyan-400">
                        Email
                      </div>
                      <input
                        type="email"
                        id="email"
                        required
                        placeholder="email@example.com"
                        name="user_email"
                        className="w-full rounded border border-primary-700/70 bg-primary-100/20 py-1 pl-16 pr-3 text-base leading-8 outline-none transition-colors duration-200 ease-in-out focus:ring-1 focus:ring-primary-700/70 dark:border-[#464646] dark:bg-primary-300/10 dark:focus:ring-primary-300/50"
                      />
                    </div>
                    <div className="w-full p-2">
                      <textarea
                        placeholder="Message here..."
                        id="message"
                        name="message"
                        required
                        className="h-52 w-full resize-none rounded border border-primary-700/70 bg-primary-100/20 py-1 px-3 text-base leading-8 outline-none transition-colors duration-200 ease-in-out focus:ring-1 focus:ring-primary-700/70 dark:border-[#464646] dark:bg-primary-300/10 dark:focus:ring-primary-300/50"
                      />
                    </div>
                    <div className="flex w-full justify-center p-2 mt-10">
                      <button
                        type="submit"
                        disabled={isSending}
                        className="text-md mb-2 inline-flex w-1/2 items-center justify-center rounded-[40px] border bg-primary-700 px-1 py-4 font-medium text-primary-50 hover:bg-primary-700/80 focus:outline-none focus:ring-2 dark:border-primary-700 dark:bg-primary-500 dark:hover:bg-primary-700 dark:focus:ring-primary-600"
                      >
                        {isSending ? (
                          "Sending..."
                        ) : (
                          <>
                            Send Now
                            <Iconify
                              classes="ml-2"
                              icon="fluent:send-16-filled"
                            />
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="flex-1 h-full sm:pl-16 ">
              <div className="flex flex-col sm:space-y-10 justify-center items-center">
                <div className="flex flex-col min-w-[380px] sm:w-[463px] px-4  py-4 bg-[#222121] rounded-md shadow-[0_10px_40px_0_rgba(50,50,50,.1)] border-[1px] border-solid border-[#464646]">
                  <div className="flex items-center space-x-6">
                    <div className="flex items-center gap-5">
                      <div className="h-12 sm:h-[60px] w-12 sm:w-[60px] flex justify-center items-center rounded-[50%] bg-[#2e2e2e]">
                        <Icon icon="mdi:address-marker-outline" width={30} />
                      </div>
                    </div>
                    <span className="text-xl sm:text-[24px] sm:font-bold mb-4 mt-0">
                      Lukfin, TX
                    </span>
                  </div>
                </div>

                <div className="flex flex-col min-w-[380px] sm:w-[463px] px-4 py-4 bg-[#222121] rounded-md shadow-[0_10px_40px_0_rgba(50,50,50,.1)] border-[1px] border-solid border-[#464646]">
                  <div className="flex flex-col items-center sm:flex-row space-y-1 sm:space-x-5">
                    <div className="flex items-center gap-5">
                      <div className="h-12 sm:h-[60px] w-12 sm:w-[60px] flex justify-center items-center rounded-[50%] bg-[#2e2e2e]">
                        <Icon icon="logos:google-gmail" />
                      </div>
                    </div>
                    <span className="text-xl sm:text-[24px] sm:font-bold mb-4 mt-0">
                      hussaink001haled@gmail.com
                    </span>
                  </div>
                </div>

                <div className="fflex flex-col min-w-[380px] sm:w-[463px] px-4  py-4 bg-[#222121] rounded-md shadow-[0_10px_40px_0_rgba(50,50,50,.1)] border-[1px] border-solid border-[#464646]">
                  <div className="flex flex-row items-center gap-6 space-y-1">
                    {" "}
                    <div className="flex items-center gap-5">
                      <div className="h-12 sm:h-[60px] w-12 sm:w-[60px] flex justify-center items-center rounded-[50%] bg-[#2e2e2e]">
                        <Icon icon="logos:skype" width={30} />
                      </div>
                    </div>
                    <span className="text-xl sm:text-[24px] sm:font-bold mb-4 mt-0">
                      +1 281-201-0578{" "}
                    </span>
                  </div>
                </div>

                <div className="flex flex-row min-w-[380px] sm:w-[463px] px-4  py-4 bg-[#222121] rounded-md shadow-[0_10px_40px_0_rgba(50,50,50,.1)] border-[1px] border-solid border-[#464646]">
                  <div className="flex flex-row items-center gap-6 space-y-1">
                    <div className="flex items-center gap-5">
                      <div className="h-12 sm:h-[60px] w-12 sm:w-[60px] flex bg-[#2e2e2e] justify-center items-center rounded-[50%]">
                        <a href="https://t.me/hukha77">
                          <Icon icon="logos:telegram" width={30} />
                        </a>
                      </div>
                    </div>
                    <span className="text-xl sm:text-[24px] sm:font-bold mb-4 mt-0">
                      hukha77
                    </span>
                  </div>
                </div>

                <div className="flex flex-row min-w-[380px] sm:w-[463px] px-4  py-4 bg-[#222121] rounded-md shadow-[0_10px_40px_0_rgba(50,50,50,.1)] border-[1px] border-solid border-[#464646]">
                  <div className="flex flex-row items-center gap-6 space-y-1">
                    <div className="flex items-center gap-5">
                      <div className="h-12 sm:h-[60px] w-12 sm:w-[60px] flex bg-[#2e2e2e] justify-center items-center rounded-[50%]">
                        <a href="https://discord.gg/rX25PRMMjC">
                          <Icon icon="logos:discord-icon" width={30} />
                        </a>
                      </div>
                    </div>
                    <span className="text-xl sm:text-[24px] sm:font-bold mb-4 mt-0">
                      huska0707
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

Contact.propTypes = {};
